// removed by extract-text-webpack-plugin
module.exports = {"component":"_3DkG7mqok-v_VxW8e-iI5B","item":"_1cEsE1W_lMQbAZ9T8k0qtd"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/HomeMiddleNav/HomeMiddleNav.scss
 ** module id = 979
 ** module chunks = 0
 **/